import { Box, Skeleton } from '@mui/material';

import { DAILY_CDP_SYNC_FLAG_FIELDS } from '../constants';

export const DailyCdpSyncSettingsSkeleton = () => {
  return (
    <Box>
      {DAILY_CDP_SYNC_FLAG_FIELDS.map(({ key }) => (
        <Box
          key={key}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            minHeight: 42,
          }}
        >
          <Skeleton variant="rounded" width={36} height={20} />
          <Skeleton variant="text" width={220} height={24} />
        </Box>
      ))}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Skeleton variant="rounded" width={88} height={36} />
      </Box>
    </Box>
  );
};
